<template>
  <v-container fluid class="asc-mx-rec-recommendation-template px-0 pt-0">
    <asc-notification
      v-if="isCautionaryDialog"
      :definition="CautionaryDialog"
      :on-close="handleCautionaryDialogClose"
    ></asc-notification>
    <v-row>
      <v-col class="pb-4">
        <asc-mx-rec-info-wrapper
          :is-investigation-tab="!isOnRecommendationTab"
          :is-recommendation-tab="isOnRecommendationTab"
          :tab-index="tabIndex"
          :issue-source="issueSource"
          :is-pre-submittal="isPreSubmittal"
          :disable-submit="isDisableSubmit"
          :lock-enabled="pageLockedForEditing"
          :airline-tier-type-id="airlineTierTypeId"
          :is-custom-alert="isCustomAlert"
          :is-chronic-repeaters="isChronicRepeaters"
          :aircraft-details="aircraftDetails"
          :status-options="statusOptions"
          :is-manually-created="isManuallyCreated"
          :locked-items="getLockedStatusOptions"
          :custom-alert-mx-rec-status-options="customAlertMxRecStatusOptions"
          :custom-alert-owner-data="detailsUsersToTag"
          :severity-options="severityOptions"
          @changeInvestigation="changeInvestigation"
          @updateStatus="handleUpdateStatus"
          @updateSeverity="handleUpdateSeverity"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-show="layout.maintRecommendation.show || layout.plot.show"
        cols="12"
        :lg="
          layout.maintRecommendation.show
            ? layout.maintRecommendation.currentCols
            : layout.plot.show
            ? layout.plot.currentCols
            : 12
        "
        order="1"
        order-lg="1"
      >
        <v-row>
          <template v-if="!isPwcUser && !isCustomAlert && isChronicRepeaters">
            <Transition name="fade">
              <v-col v-show="layout.plot.show" cols="12">
                <asc-panel
                  flat
                  has-fullscreen-icon
                  :content-min-height="324"
                  @onFullScreenToggle="
                    handleFullScreenToggle('plot', !layout.plot.isExpanded)
                  "
                >
                  <template #title>Plots</template>
                  <asc-plotly
                    :plotly-data="mappedPlotlyData"
                    :re-render="reRenderPlotly"
                    :is-dirty="isPlotlyDirty"
                    :chronic-repeaters-data="
                      isChronicRepeatersRelatedEvents
                        ? {
                            pagename: 'related_events',
                            repeaterId: repeaterId,
                            issueId: issueId,
                          }
                        : undefined
                    "
                    :is-readonly="
                      isReadOnlyPermissionInvestigate || reEntrantLockObtained
                    "
                    @onRelatedEventGridChange="handleRelatedEventGridChange"
                    @onIssueCreation ="handleOnIssueCreation"
                    @onRepeaterRelatedEventGridChange ="handleRepeaterRelatedEventGridChange"
                  />
                </asc-panel>
              </v-col>
            </Transition>
          </template>

          <Transition name="fade">
            <v-col v-show="layout.maintRecommendation.show" cols="12">
              <asc-panel
                flat
                has-fullscreen-icon
                :content-max-height="isChronicRepeaters ? 443 : 342"
                :content-padding-y="0"
                :content-padding-bottom="isChronicRepeaters ? 16 : undefined"
                @onFullScreenToggle="
                  handleFullScreenToggle(
                    'maintRecommendation',
                    !layout.maintRecommendation.isExpanded,
                  )
                "
              >
                <asc-mx-rec-details-followup-wrapper
                  :is-recommendation-tab="isOnRecommendationTab"
                  :airline-tier-type-id="airlineTierTypeId"
                  :fields="mxRecDetailsFormFields"
                  :files="getMaintenanceAttachments"
                  :file-type-properties="getFileTypeProperties('MaintIssue')"
                  :data="getMxRecFollowUpInfo"
                  :tab-index="tabIndex"
                  :mx-action-attachment-upload-error="
                    mxActionAttachmentUploadError
                  "
                  :is-custom-alert="isCustomAlert"
                  :lock-enabled="pageLockedForEditing"
                  :is-chronic-repeaters="isChronicRepeaters"
                  :plotly-data="plotlyData"
                  :repeater-id="repeaterId"
                  @downloadFile="handleFileDownload"
                  @fileSelected="handleFileSelected"
                  @fileUploaded="handleFileUpload"
                  @updateFollowUpFields="handleUpdateMxRecFollowUpFields"
                  @followUpDataChanges="handleFollowUpDataChanges"
                >
                </asc-mx-rec-details-followup-wrapper>
              </asc-panel>
            </v-col>
          </Transition>

          <template v-if="!isPwcUser && !isCustomAlert && !isChronicRepeaters">
            <Transition name="fade">
              <v-col v-show="layout.plot.show" cols="12">
                <asc-panel
                  flat
                  has-fullscreen-icon
                  :content-min-height="324"
                  @onFullScreenToggle="
                    handleFullScreenToggle('plot', !layout.plot.isExpanded)
                  "
                >
                  <template #title>Plots</template>
                  <asc-plotly
                    :plotly-data="mappedPlotlyData"
                    :re-render="reRenderPlotly"
                    :is-dirty="isPlotlyDirty"
                    :chronic-repeaters-data="
                      isChronicRepeatersRelatedEvents
                        ? {
                            pagename: 'related_events',
                            repeaterId: repeaterId,
                            issueId: issueId,
                          }
                        : undefined
                    "
                    :is-readonly="
                      isReadOnlyPermissionInvestigate || reEntrantLockObtained
                    "
                    @onRelatedEventGridChange="handleRelatedEventGridChange"
                    @onIssueCreation ="handleOnIssueCreation"
                    @onRepeaterRelatedEventGridChange ="handleRepeaterRelatedEventGridChange"
                  />
                </asc-panel>
              </v-col>
            </Transition>
          </template>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        :lg="
          layout.recentActvity.show
            ? layout.recentActvity.currentCols
            : layout.relatedIssues.show
            ? layout.relatedIssues.currentCols
            : layout.upcomingFlights.show
            ? layout.upcomingFlights.currentCols
            : 12
        "
        order="3"
        order-lg="2"
      >
        <v-row>
          <Transition name="fade">
            <v-col v-show="layout.recentActvity.show" cols="12">
              <asc-panel
                flat
                has-fullscreen-icon
                :content-max-height="715"
                :content-padding-x="0"
                :loading="isDetailsDiscussionLoading"
                @onFullScreenToggle="
                  handleFullScreenToggle(
                    'recentActvity',
                    !layout.recentActvity.isExpanded,
                  )
                "
              >
                <template #title>Activity Log</template>
                <asc-user-comment-list-wrapper
                  :user-comments="detailsDiscussion"
                  :user="user"
                  :discussion-type-id="detailsDiscussionTypeId"
                  :user-list="detailsUsersToTag"
                  :status-updates="detailsStatusUpdates"
                  :reset-comment="resetDetailsComment"
                  :restore-discussions="restoreDiscussions"
                  :disabled="
                    !recentActivityEditable || isDetailsDiscussionLoading
                  "
                  :max-list-height="715"
                  :is-expanded="layout.recentActvity.isExpanded"
                  :comment-change-event-on-blur="false"
                  has-post-btn
                  @onPostClick="handlePostClick"
                  @addUserComment="handleNewComment"
                  @deleteComment="handleDeleteUserComment"
                  @updateComment="handleUpdateUserComment"
                  @removeUnsavedComment="handleRemoveUnsavedComment"
                  @hasData="handleHasData"
                  @commentText="handlecommentText"
                />
              </asc-panel>
            </v-col>
          </Transition>

          <Transition name="fade">
            <v-col v-show="layout.relatedIssues.show" cols="12">
              <asc-panel
                flat
                has-fullscreen-icon
                :content-max-height="365"
                :loading="relatedAlertsLoading"
                @onFullScreenToggle="
                  handleFullScreenToggle(
                    'relatedIssues',
                    !layout.relatedIssues.isExpanded,
                  )
                "
              >
                <template #title>
                  {{ getRelatedAlertsHeader }}
                </template>
                <asc-related-mx-recs-wrapper
                  :values="relatedAlerts"
                  :aircraft-details="aircraftDetails"
                  :is-recommendation-tab="isOnRecommendationTab"
                  :is-expanded="layout.relatedIssues.isExpanded"
                />
              </asc-panel>
            </v-col>
          </Transition>

          <Transition name="fade">
            <v-col v-show="layout.upcomingFlights.show" cols="12">
              <asc-panel
                :key="`${layout.upcomingFlights}`"
                flat
                has-fullscreen-icon
                :loading="isUpcomingFlightsLoading"
                :content-max-height="593"
                @onFullScreenToggle="
                  handleFullScreenToggle(
                    'upcomingFlights',
                    !layout.upcomingFlights.isExpanded,
                  )
                "
              >
                <template #title>
                  Upcoming Flights for {{ aircraftDetails.tail.name }}
                </template>
                <template #subtitle>
                  <div class="row">
                    <div
                      :class="
                        layout.upcomingFlights.isExpanded
                          ? 'col-md-10 col-sm-6'
                          : 'col-md-12 mb-n1'
                      "
                    >
                      Powered by
                      <img
                        style="
                          height: 30px;
                          width: auto;
                          position: relative;
                          bottom: -4px;
                        "
                        src="../../assets/Flight_Aware.png"
                      />
                    </div>
                    <div
                      :class="
                        layout.upcomingFlights.isExpanded
                          ? 'col-md-2 pt-6 pr-2 d-flex justify-end col-sm-6'
                          : 'col-md-12 mt-n1'
                      "
                    >
                      <a
                        :href="flightSchedule"
                        style="text-decoration: underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Flight Schedule
                        <v-icon center :size="13">
                          {{ 'mdi-open-in-new' }}
                        </v-icon>
                      </a>
                    </div>
                  </div>
                </template>
                <asc-mx-rec-upcoming-flights-wrapper
                  :is-expanded="layout.upcomingFlights.isExpanded"
                  :issue-id="issueId"
                  :flight-aware-last-updated-date="flightAwareLastUpdatedDate"
                  :future-flight-schedules="futureFlightSchedules"
                  :tail-name="aircraftDetails.tail.name"
                />
              </asc-panel>
            </v-col>
          </Transition>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AscPanel from '../atoms/AscPanel.vue'

import AscUserCommentListWrapper from '../organisms/AscUserCommentListWrapper.vue'
import AscNotification from '../molecules/AscNotification.vue'

import AscUserCommentPropsMixin from '../mixins/AscUserCommentPropsMixin.vue'
import AscMxRecPropsMixin from '../mixins/AscMxRecPropsMixin.vue'
import AscMxRecPermissionMixin from '../mixins/AscMxRecPermissionMixin.vue'
import AscMxRecInfoWrapper from '../organisms/AscMxRecInfoWrapper.vue'
import AscMxRecDetailsFollowupWrapper from '../organisms/AscMxRecDetailsFollowupWrapper.vue'
import AscPlotly from '../molecules/AscPlotly.vue'
import AscMxRecUpcomingFlightsWrapper from '../organisms/AscMxRecUpcomingFlightsWrapper.vue'
import AscRelatedMxRecsWrapper from '../organisms/AscRelatedMxRecsWrapper.vue'
import _isEqual from 'lodash/isEqual'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'AscMxRecRecommendationTemplate',

  components: {
    AscPanel,
    AscPlotly,
    AscUserCommentListWrapper,
    AscMxRecInfoWrapper,
    AscMxRecDetailsFollowupWrapper,
    AscMxRecUpcomingFlightsWrapper,
    AscRelatedMxRecsWrapper,
    AscNotification,
  },

  mixins: [
    AscMxRecPropsMixin,
    AscUserCommentPropsMixin,
    AscMxRecPermissionMixin,
  ],

  props: {
    // Refer AscMxRecPropsMixin for rest of props
    issueId: {
      type: Number,
      required: true,
    },
    customAlertMxRecStatusOptions: {
      type: Array,
      default: () => [],
    },
    reEntrantLockObtained: {
      type: Boolean,
      default: false,
    },
    changesMade: {
      type: Boolean,
      default: false,
    },
    plotlyData: {
      type: Object,
      default: () => {},
    },
    aircraftDetails: {
      type: Object,
      default: () => {},
    },
    // Infowrapper
    isDisableSubmit: {
      type: Boolean,
      default: true,
    },
    // RecentActivity
    detailsDiscussion: {
      type: Array,
      default: () => [],
    },
    detailsStatusUpdates: {
      type: Array,
      default: () => [],
    },
    detailsUsersToTag: {
      type: Array,
      default: () => [],
    },
    detailsDiscussionTypeId: {
      type: Number,
      required: true,
    },
    restoreDiscussions: {
      type: Boolean,
      default: false,
    },
    resetDetailsComment: {
      type: Boolean,
      default: false,
    },
    // Upcoming flight schedules
    isUpcomingFlightsLoading: {
      type: Boolean,
      default: false,
    },
    flightAwareLastUpdatedDate: {
      type: String,
      default: null,
    },
    futureFlightSchedules: {
      type: Array,
      default: () => [],
    },
    relatedAlerts: {
      type: Array,
      default: () => [],
    },
    isDetailsDiscussionLoading: {
      type: Boolean,
      default: true,
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    mxRecDetailsFormFields: {
      type: Object,
      default: () => {},
    },
    fileTypes: {
      type: Array,
      default: () => [],
    },
    mxActionAttachmentUploadError: {
      type: Array,
      default: () => [],
    },
    lockedStatusOptions: {
      type: Array,
      default: () => [],
    },
    //Related Alerts
    relatedAlertsLoading: {
      type: Boolean,
      default: false,
    },
    // Plotly
    reRenderPlotly: {
      type: Boolean,
      default: false,
    },
    isPlotlyDirty: {
      type: Boolean,
      default: false,
    },
    issueSource: {
      type: Boolean,
      default: false,
    },
    isPwcUser: {
      type: Boolean,
      default: false,
    },
    severityOptions: {
      type: Array,
      default: () => [],
    },
    repeaterId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      layout: {
        maintRecommendation: {
          cols: 9,
          currentCols: !this.isPwcUser ? 9 : 12,
          order: 1,
          show: true,
          isExpanded: false,
        },
        recentActvity: {
          cols: 3,
          currentCols: !this.isPwcUser ? 3 : 12,
          order: 2,
          show: true,
          isExpanded: false,
        },
        plot: {
          cols: 9,
          currentCols: 9,
          order: 3,
          show: true,
          isExpanded: false,
        },
        relatedIssues: {
          cols: 3,
          currentCols: !this.isPwcUser ? 3 : 12,
          order: 4,
          show: true,
          isExpanded: false,
        },
        upcomingFlights: {
          cols: 3,
          currentCols: !this.isPwcUser ? 3 : 12,
          order: 5,
          show: true,
          isExpanded: false,
        },
      },
      CautionaryDialog: [
        {
          color: 'warning',
          isActive: true,
          text: 'Assign one or more related events to finish creating this issue.',
          type: 'warning',
        },
      ],
    }
  },

  computed: {
    isCautionaryDialog() {
      return (
        this.aircraftDetails?.isManualRepeater &&
        !this.aircraftDetails?.isDashSelection
      )
    },
    recentActivityEditable() {
      if (
        this.isMxRecEditPermission ||
        this.isCustomAlert ||
        this.isEditPermissionInvestigate
      ) {
        return true
      }
      return false
    },
    getLockedStatusOptions() {
      return this.lockedStatusOptions
    },

    flightSchedule() {
      return (
        'http://flightaware.com/live/flight/' + this.aircraftDetails?.tail?.name
      )
    },

    isOnRecommendationTab() {
      if (this.isMxRecEditPermission || this.isCustomAlert) {
        return true
      } else {
        return this.isRecommendationTab
      }
    },

    pageLockedForEditing() {
      return this.reEntrantLockObtained
    },

    getMaintenanceAttachments() {
      return this.aircraftDetails?.attachments?.filter(file =>
        file?.filename.match('MaintIssue'),
      )
    },

    getRelatedAlertsHeader() {
      const tailName = this.aircraftDetails?.tail?.name || ''
      const ataChapter = this.aircraftDetails?.ataChapter || ''
      const ataChapterArray = ataChapter.split(',')
      let header

      if (this.isPwcUser) {
        header = '49'
      } else {
        if (ataChapterArray.length === 1) {
          header = ataChapterArray[0]
        } else if (ataChapterArray.length === 2) {
          header = ataChapterArray.join(' AND ')
        } else {
          header =
            ataChapterArray.slice(0, -1).join(', ') +
            ' AND ' +
            ataChapterArray.slice(-1)
        }
      }

      return `Related Issues for ATA ${header} ON ${tailName}`
    },

    getMxRecFollowUpInfo() {
      return {
        airlineResponseId: this.aircraftDetails?.airlineResponseId
          ? this.aircraftDetails.airlineResponseId
          : 2,
        dateCompleted: this.aircraftDetails?.dateCompleted,
        serviceAlertNumber: this.aircraftDetails?.serviceAlertNumber,
        purchaseOrderNumber: this.aircraftDetails?.purchaseOrderNumber,
        removedPartNumber: this.aircraftDetails?.removedPartNumber,
        removedPartSerialNumber: this.aircraftDetails?.removedPartSerialNumber,
        installedPartNumber: this.aircraftDetails?.installedPartNumber,
        installedPartSerialNumber:
          this.aircraftDetails?.installedPartSerialNumber,
      }
    },

    isChronicRepeatersRelatedEvents() {
      return (
        this.isChronicRepeaters &&
        this.plotlyData['RelatedEvents'] &&
        this.repeaterId
      )
    },

    mappedPlotlyData() {
      if (this.isChronicRepeatersRelatedEvents) {
        return this.plotlyData['RelatedEvents']
      }

      if (this.plotlyData['MxRec']) {
        return this.plotlyData['MxRec']
      }

      return null
    },
  },

  watch: {
    saveDisabled(newValue) {
      const changes = !newValue
      this.$emit('update:changesMade', changes)
      this.$emit('input', changes)
      this.$emit('change', changes)
    },
  },

  destroyed() {
    this.statusId = null
  },

  methods: {
    handleFullScreenToggle(component, isExpanded) {
      if (this.isPwcUser) {
        for (const key in this.layout) {
          if (isExpanded) {
            this.layout[key].show = false
          } else {
            this.layout[key].show = true
          }
          if (Object.hasOwnProperty.call(this.layout, key)) {
            if (key === component && isExpanded) {
              this.layout[key] = {
                ...this.layout[key],
                currentCols: 12,
                show: true,
                isExpanded: isExpanded,
              }
            } else {
              this.layout[key] = {
                ...this.layout[key],
                currentCols: 12,
                isExpanded: false,
              }
            }
          }
        }
      } else {
        for (const key in this.layout) {
          if (isExpanded) {
            this.layout[key].show = false
          } else {
            this.layout[key].show = true
          }

          if (Object.hasOwnProperty.call(this.layout, key)) {
            if (key === component && isExpanded) {
              this.layout[key] = {
                ...this.layout[key],
                currentCols: 12,
                show: true,
                isExpanded: isExpanded,
              }
            } else {
              this.layout[key] = {
                ...this.layout[key],
                currentCols: this.layout[key].cols,
                isExpanded: false,
              }
            }
          }
        }
      }
    },
    changeInvestigation() {
      this.$emit('changeInvestigation', 'submit')
    },
    handleUpdateStatus(newStatusId) {
      if (this.aircraftDetails?.status?.id != newStatusId) {
        this.$emit('isSaveDisabled', false)
        this.$emit('updateMxRecStatusId', newStatusId)
      }
    },
    handlePostClick(commentInfo) {
      this.$emit('onPostClick', commentInfo)
    },

    handleNewComment(commentInfo) {
      this.$emit('addUserComment', commentInfo)
    },

    handleDeleteUserComment(commentInfo) {
      this.$emit('deleteUserComment', commentInfo)
    },

    handleUpdateUserComment(commentInfo) {
      this.$emit('updateUserComment', commentInfo)
    },
    handleHasData(data) {
      this.$emit('hasData', data)
    },
    handlecommentText(data) {
      this.$emit('commentText', data)
    },
    handleChangesMade(data) {
      this.$emit('changesMade', data)
    },

    handleRemoveUnsavedComment(comment) {
      this.$emit('removeUnsavedComment', comment)
    },

    getFileTypeProperties(whichAttachmentType) {
      const attachmentFileType = this.fileTypes
        .filter(file => file.filenameSuffix === whichAttachmentType)
        .pop()
      return attachmentFileType
    },

    handleUpdateMxRecFollowUpFields(followUpInfo) {
      const isEqual = _isEqual(
        _sortBy({ ...this.getMxRecFollowUpInfo }),
        _sortBy({ ...followUpInfo }),
      )

      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        this.$emit('updateMxRecFollowUpFields', followUpInfo)
      }
    },

    handleFollowUpDataChanges() {
      this.$emit('followUpDataChanges', true)
    },

    handleFileDownload(fileToDownload) {
      this.$emit('downloadFile', fileToDownload)
    },

    handleFileSelected(file) {
      this.$emit('isSaveDisabled', false)

      if (file.remove) {
        this.$emit('fileUpdate', file)
      } else if (file.cancel) {
        this.$emit('fileUpdate', { cancel: true, uploadToCancel: file })
      } else {
        this.$emit('fileUpdate', { update: true, fileToUpdate: file })
      }
    },

    handleFileUpload(file) {
      this.$emit('isSaveDisabled', false)
      this.$emit('fileUpdate', { fileToSave: file })
    },

    handleRelatedEventGridChange(data) {
      // TODO: check and change base on chronic repeater event here
      this.$emit('onRelatedEventGridChange', data)
    },

    handleOnIssueCreation(data){
      this.$emit('onIssueCreation', data)
    },

    handleRepeaterRelatedEventGridChange(data){
      this.$emit('onRepeaterRelatedEventGridChange', data)
    },

    handleUpdateSeverity(severityId) {
      const isEqual = _isEqual(this.aircraftDetails?.severityId, severityId)
      if (!isEqual) {
        this.$emit('isSaveDisabled', false)
        // update store here
        this.$emit('updateMxRecAlertDetails', {
          severityId: severityId,
        })
      }
    },
    handleCautionaryDialogClose(value) {
      this.CautionaryDialog[0].isActive = value.isActive
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-mx-rec-recommendation-template {
  position: relative;

  .row {
    margin: -8px;
  }
  .row > .col,
  .row > [class*='col-'] {
    padding: 8px;
  }

  // Transition
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
